import React, { useRef, useCallback } from 'react';
import DropdownChevron from '../DropdownChevron';
import ClosedDropdownIcon from '../DropdownChevron/ClosedDropdownIcon';
import { miniGazelle } from '../../../../../helpers';

const ProductFilters = ({
    productFilters,
    visibleOptions,
    toggleFilterVisibility,
    isFilterOptionChecked,
    filterProducts,
}) => {
    const filterRefs = useRef([]);
    const filterProductsCallback = useCallback((option, filterName, filterTitle) => () => {
        filterProducts(option, filterName, filterTitle);
    });
    const toggleFilterVisibilityCallback = useCallback(index => () => toggleFilterVisibility(index));
    const handleKeyPressCallback = useCallback(index => event => handleKeyPress(event, index));

    const handleKeyPress = (event, index) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleFilterVisibility(index);
        }
    };

    const handleCheckboxKeyPress = (event, option, filterKey, attributeId) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            filterProductsCallback(option, filterKey, attributeId)();
        }
    };

    return (
        <section className="product-filters" data-testid="product-filter">
            <div className="filter-section h3" role="heading" aria-level="3" aria-label="Product Filters Section">
                <strong>{miniGazelle.label('filterTitle', true)}</strong>
            </div>
            {productFilters.map((filter, index) => (
                <div key={index} className="filter-section" ref={el => (filterRefs.current[index] = el)}>
                    <div
                        className={`filter-dropdown-header ${visibleOptions[index] ? 'open' : ''}`}
                        role="button"
                        tabIndex={0}
                        onClick={toggleFilterVisibilityCallback(index)}
                        onKeyUp={handleKeyPressCallback(index)}
                        aria-label={`Expand ${miniGazelle.label(filter.attributeId, true)} options`}
                    >
                        <p className={`${visibleOptions[index] ? 'selected' : ''}`} aria-hidden={true}>
                            {miniGazelle.label(filter.attributeId, true)}
                        </p>
                        <div className={`filter-toggle-button ${visibleOptions[index] ? 'open' : ''}`} tabIndex={-1}>
                            {visibleOptions[index] ? <DropdownChevron /> : <ClosedDropdownIcon />}
                        </div>
                    </div>

                    <div
                        className={`filter-option-dropdown ${visibleOptions[index] ? 'show' : ''}`}
                        style={{ maxHeight: visibleOptions[index] ? '500px' : '0' }}
                        onClick={e => e.stopPropagation()}
                        role="listbox"
                        aria-label={`Filter Options List : ${filter.options.length} items`}
                        aria-hidden={visibleOptions[index] ? false : true}
                        tabIndex={-1}
                    >
                        {filter.options.map((option, i) => {
                            const isSelected = isFilterOptionChecked(option);
                            return (
                                <label key={i} className="filter-option" tabIndex={-1}>
                                    <input
                                        tabIndex={visibleOptions[index] ? 0 : -1}
                                        type="checkbox"
                                        aria-label={option}
                                        checked={isSelected}
                                        onClick={filterProductsCallback(option, filter.filterKey, filter.attributeId)}
                                        onKeyDown={e =>
                                            handleCheckboxKeyPress(e, option, filter.filterKey, filter.attributeId)
                                        }
                                    />
                                    <p aria-hidden={true} className={isSelected ? 'is-selected' : ''}>
                                        {option}
                                    </p>
                                </label>
                            );
                        })}
                    </div>
                </div>
            ))}
        </section>
    );
};

export default ProductFilters;
